<template>
  <StackedBarChart :chart-data="rateAgentTimeLineChartData"></StackedBarChart>
</template>
<script>
import StackedBarChart from "components/charts/StackedBarChart";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "RateAgentTimeLine",
  components: {StackedBarChart},
  mounted() {
    this.refresh()
  },
  computed: {
    ...mapGetters('rating', ['rateAgentTimeLineChartData'])
  },
  methods: {
    ...mapActions('rating', ['listRateAgentByTime']),
    refresh() {
      this.listRateAgentByTime()
    }
  },
}
</script>

<style scoped>

</style>